// ============================================================================
// AppFooter - Corporate Footer for Authenticated Pages
// Matches edupath.africa branding with compact in-app version
// ============================================================================

import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid md:grid-cols-4 gap-6 mb-6">
          {/* Brand */}
          <div className="md:col-span-2">
            <img src="/edupath-logo.png" alt="EduPath Africa" className="h-8 mb-3 brightness-0 invert" />
            <p className="text-gray-400 text-sm max-w-sm">
              AI-powered career guidance for Kenya's Competency-Based Curriculum. 
              Helping learners discover their perfect pathway.
            </p>
            <a 
              href="mailto:hello@edupath.africa" 
              className="inline-block mt-2 text-accent-400 hover:text-accent-300 text-sm font-medium transition-colors"
            >
              hello@edupath.africa
            </a>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Product</h4>
            <ul className="space-y-1.5 text-gray-400 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Support</h4>
            <ul className="space-y-1.5 text-gray-400 text-sm">
              <li><a href="mailto:hello@edupath.africa" className="hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="https://edupath.africa" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">edupath.africa</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-4 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} EduPath Africa Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-gray-500 text-xs">
            <span>🇰🇪 Made in Kenya</span>
            <a href="https://edupath.africa" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              edupath.africa
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
